module.exports = __webpack_public_path__ + "images/logo-color@2x.5e4a7c49c6acff3b2ddf6502b89d0aab.png";